import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Message } from '@weezevent/nacre';

/*
 * FormErrorsSummary is able to deal with nested objects in form errors.
 * Exemple of formErrors :
 * {
 *    One : t("key.trad.for.one"),
 *    Two : {subTwo : t("key.trad.for.subtwo"), subTwoBis : t("key.trad.for.subtwoBis")}
 * }
 */

export default function FormErrorsSummary({ formErrors, fieldsTrads }) {
    const { t } = useTranslation();

    const ErrorsList = ({ currentErrors, currentFieldsTrads }) => {
        return (
            <>
                {Object.entries(currentErrors).map(([field, error]) =>
                    typeof error === 'object' && error !== null ? (
                        <ErrorsList currentErrors={error} currentFieldsTrads={fieldsTrads[field]} />
                    ) : (
                        <li key={field}>
                            <strong>{currentFieldsTrads[field]}</strong> : {t(error)}
                        </li>
                    )
                )}
            </>
        );
    };

    return (
        <>
            {formErrors && Object.keys(formErrors).length > 0 && (
                <Message title={t('ticket.formErrorsSummary.title')} type="danger" visible>
                    <ul>
                        <ErrorsList currentErrors={formErrors} currentFieldsTrads={fieldsTrads} />
                    </ul>
                </Message>
            )}
        </>
    );
}

FormErrorsSummary.propTypes = {
    formErrors: PropTypes.object,
    fieldsTrads: PropTypes.object
};

FormErrorsSummary.defaultProps = {
    formErrors: null,
    fieldsTrads: null
};
